import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddProductModal from "../../components/modals/AddProductModal/AddResourceModal";
import EditProductModal from "../../components/modals/EditProductModal/EditProductModal";
import ProductsFilterModal from "../../components/modals/filters/ProductsFilterModal/ProductsFilterModal";
import { SelectOption } from "../../components/modals/forms/inputs/SelectInput/SelectInput";
import Pagination from "../../components/pagination/Pagination/Pagination";
import ProductsTable from "../../components/Tables/ProductsTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IBrand } from "../../types/brands.type";
import { ICategory } from "../../types/category.type";
import { IDiscount } from "../../types/discount.type";
import { IProduct } from "../../types/product.type";
import { IProductType } from "../../types/productType.type";
import { ITags } from "../../types/tags.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterProducts } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const ProductsPage: React.FC = () => {
  const [products, setProducts] = useState<IProduct[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<IProduct[]>([]);
  const [editSelectedProduct, setEditSelectedProduct] =
    useState<IProduct | null>(null);
  const [visibleProducts, setVisibleProduct] = useState<IProduct[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isAddProductModal, setIsAddProductModal] = useState<boolean>(false);
  const [isInfoModal, setInfoModal] = useState<boolean>(false);
  const [tags, setTags] = useState<ITags[]>([]);
  const [brands, setBrands] = useState<IBrand[]>([]);
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [types, setTypes] = useState<IProductType[]>([]);
  const [discounts, setDiscounts] = useState<IDiscount[]>([]);
  const [isFilterModal, setIsFilterModal] = useState<boolean>(false);
  const [defaultBrand, setDefaultBrand] = useState<SelectOption>({
    value: "none",
    label: "Будь яка",
  });
  const [defaultCategory, setDefaultCategory] = useState<SelectOption>({
    value: "none",
    label: "Будь яка",
  });
  const [defaultType, setDefaultType] = useState<SelectOption>({
    value: "none",
    label: "Будь яка",
  });

  const getProducts = async () => {
    try {
      const results = await authApiService.getAllProducts();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const getTags = async () => {
    try {
      const results = await authApiService.getAllTags();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const getBrands = async () => {
    try {
      const results = await authApiService.getAllBrands();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const getCategories = async () => {
    try {
      const results = await authApiService.getAllCategories();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const getTypes = async () => {
    try {
      const results = await authApiService.getAllProductTypes();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const getDiscounts = async () => {
    try {
      const results = await authApiService.getAllDiscounts();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const changeVisibiltyProducts = (products: IProduct[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (products) {
      const changedProducts = products.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleProduct(changedProducts);
    }
  };

  const getOptionsFilter = (
    brand: SelectOption,
    category: SelectOption,
    type: SelectOption
  ) => {
    let filteredProducts = [...products];
    // setRole(role);
    setDefaultBrand(brand);
    setDefaultCategory(category);
    setDefaultType(type);

    if (brand.value !== "none") {
      filteredProducts = filteredProducts.filter(
        (user) => user.brand.id === brand.value
      );
    }

    if (category.value !== "none") {
      filteredProducts = filteredProducts.filter(
        (user) => user.category.id === category.value
      );
    }

    if (type.value !== "none") {
      filteredProducts = filteredProducts.filter(
        (user) => user.productType.id === type.value
      );
    }

    return filteredProducts;
  };

  const onFilterChange = (
    brand: SelectOption,
    category: SelectOption,
    type: SelectOption
  ) => {
    const data = getOptionsFilter(brand, category, type);
    const filteredUsers = filterProducts(data, searchValue);
    setFilteredProducts(filteredUsers);
  };

  const getFiltredProducts = (products: IProduct[]) => {
    const data = getOptionsFilter(defaultBrand, defaultCategory, defaultType);
    const filtered = filterProducts(data, searchValue);
    setFilteredProducts(filtered);
  };

  const onClickApplyModal = async () => {
    const resp = await getProducts();
    if (resp) {
      setProducts(resp);
      getFiltredProducts(resp);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredProducts.length / usersPerPage));
  }, [filteredProducts]);

  useEffect(() => {
    getFiltredProducts(products);
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, products]);

  useEffect(() => {
    (async () => {
      const data = await getProducts();
      if (data) {
        setProducts(data);
      }
      const resData = await getTags();
      if (resData) {
        setTags(resData);
      }

      const br = await getBrands();
      if (br) {
        setBrands(br);
      }

      const cat = await getCategories();
      if (cat) {
        setCategories(cat);
      }

      const ts = await getTypes();
      if (ts) {
        setTypes(ts);
      }

      const dis = await getDiscounts();
      if (dis) {
        setDiscounts(dis);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyProducts(filteredProducts);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, products, totalPages, filteredProducts]);
  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всього" count={products?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onSearchChange={(value) => setSearchValue(value)}
            onPressAdd={() => setIsAddProductModal(true)}
            addButtonTitle="Додати виріб"
            onPressModal={() => setIsFilterModal(true)}
          />
        </div>
      </div>

      <ProductsTable
        products={visibleProducts}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedProduct}
      />

      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />

      {isAddProductModal && (
        <AddProductModal
          onApply={onClickApplyModal}
          onClose={() => setIsAddProductModal(false)}
          tags={tags}
          brands={brands}
          categories={categories}
          types={types}
          discounts={discounts}
        />
      )}
      {editSelectedProduct && (
        <EditProductModal
          onClose={() => setEditSelectedProduct(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
          product={editSelectedProduct}
          tags={tags}
          brands={brands}
          categories={categories}
          types={types}
          discounts={discounts}
        />
      )}
      {isFilterModal && (
        <ProductsFilterModal
          types={types}
          category={categories}
          brands={brands}
          defaultBrand={defaultBrand}
          defaultCategory={defaultCategory}
          defaultType={defaultType}
          onClose={() => setIsFilterModal(false)}
          onApply={onFilterChange}
        />
      )}
    </main>
  );
};

export default ProductsPage;
